import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

/** Dropdown over a reference list ({value,label}) — the shape every reference endpoint returns. */
export const RefSelect = ({ list, value, onChange, placeholder, testId }) => (
  <Select value={value || undefined} onValueChange={onChange}>
    <SelectTrigger data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent className="max-h-64">
      {(list || []).map((x) => <SelectItem key={x.value} value={x.value}>{x.label}</SelectItem>)}
    </SelectContent>
  </Select>
);
